import { gsap } from 'gsap'
import App from '../app'

export default class Header {
  constructor() {
    this.animating = false
    this.opened = false
    this.burgerCount = 0
    this.isWheel = false

    this.bindMethods()
    this.getElems()
    this.events()

    this.currentImg = this.burgerMenuImg
    this.nextImg = this.burgerMenuImgNext

    gsap.set(this.burgerMenuItems, { xPercent: -100, opacity: 0 })
    gsap.set(this.burgerMenuImg, { backgroundImage: 'url(' + this.burgerMenuActive.img.currentSrc + ')' })
    gsap.set(this.burgerMenuPanel, { clipPath: 'inset(-2% 0% -2% 0%)' })
  }

  /**
   * Gets menu's DOM elements
   *
   * @returns {void}
   */
  getElems() {
    // this.langSwitchers = document.querySelectorAll('.lang-switcher [data-lang]')
    this.el = document.body.querySelector('#header')
    this.burgerMenu = document.body.querySelector('.js-header-burger-menu')
    this.btnSwitch = this.el.querySelector('.js-header-btn-switch')
    this.burgerBtn = this.el.querySelector('.js-header-burger-btn')
    this.burgerBg = this.burgerMenu.querySelector('.js-header-burger-bg')
    this.burgerMenuList = this.burgerMenu.querySelector('.js-header-burger-menu-list')
    this.burgerMenuItems = this.burgerMenu.querySelectorAll('.js-header-burger-menu-item')
    this.burgerMenuActive = this.burgerMenuItems[0]
    this.burgerMenuMedia = this.burgerMenu.querySelector('.js-header-burger-media')
    this.burgerMenuImg = this.burgerMenu.querySelector('.js-header-burger-img')
    this.burgerMenuImgNext = this.burgerMenu.querySelector('.js-header-burger-img-next')
    this.burgerMenuPanel = this.burgerMenu.querySelectorAll('.js-header-burger-panel')

    this.burgerMenuItems.forEach((item) => {
      item.img = item.querySelector('img')
    })
  }

  /**
   * Bind events
   *
   * @returns {void}
   */
  bindMethods() {
    this.toggle = this.toggle.bind(this)
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.toggleTheme = this.toggleTheme.bind(this)
    this.wheelMenu = this.wheelMenu.bind(this)
  }

  /**
   * Launches events on DOM elements
   *
   * @returns {void}
   */
  events() {
    this.btnSwitch.addEventListener('click', this.toggleTheme)
    this.burgerBtn.addEventListener('click', this.toggle)
    this.burgerMenu.addEventListener('mousewheel', this.wheelMenu)
  }

  toggleTheme() {
    document.body.classList.toggle('app--dark')
  }

  wheelMenu(e) {
    if (this.isWheel || this.animating || !App.isDevice('laptop-min')) return
    if (this.burgerCount == 0 && e.deltaY < 0) return
    if (this.burgerCount == (this.burgerMenuItems.length - 1) && e.deltaY > 0) return

    e.deltaY > 0 ? this.burgerCount++ : this.burgerCount--

    this.toggleBurgerMenuActive(false)
    this.burgerMenuActive = this.burgerMenuItems[this.burgerCount]
    this.isWheel = true
    this.burgerMenuActive.class

    // const value = this.burgerMenuList.offsetHeight / (this.burgerMenuItems.length - 1)
    const tl = gsap.timeline({
      onComplete: () => {
        const current = this.currentImg

        this.currentImg = this.nextImg
        this.nextImg = current
        this.isWheel = false
      }
    })

    tl.to(this.burgerMenuItems, {
      y: -this.burgerMenuItems[0].offsetHeight * this.burgerCount, duration: 0.6, ease: 'power2.out', stagger: {
        each: 0.025, from: e.deltaY > 0 ? 'start' : 'end'
      }
    }, 'start')

    tl.add(this.burgerUpdateImg(), 'start')

    tl.add(() => {
      this.toggleBurgerMenuActive(true)
    }, '-=0.5')
  }

  toggleBurgerMenuActive(bool) {
    this.burgerMenuActive.classList.toggle('active', bool)
  }

  burgerUpdateImg() {
    const tl = gsap.timeline()

    tl.set(this.nextImg, { backgroundImage: 'url(' + this.burgerMenuActive.img.currentSrc + ')' })
    tl.addLabel('step1')
    tl.to(this.currentImg, { duration: 1, opacity: 0, ease: 'power2.out' }, 'step1')
    tl.to(this.nextImg, { duration: 1, opacity: 1, ease: 'power2.out' }, 'step1')

    return tl
  }

  /**
   * Animates the menu opening
   *
   * NOTE: Turn `this.animating` to `false` on anim END
   * NOTE: Turn `this.opened` to `true` on anim END
   *
   * @returns {void}
   */
  open() {
    App.scroll(false)

    this.opened = true
    this.disabled(false)
    this.toggleBtnBurger(true)

    const tl = gsap.timeline({
      onComplete: () => {
        this.animating = false
        App.cursor.toggleScroll(true)
      }
    })

    tl.set(this.burgerMenu, { opacity: 1 })

    tl.to(this.burgerBg, {
      opacity: 1, duration: 0.7, ease: 'power2.out'
    })

    tl.addLabel('step1')

    tl.set(this.burgerMenuMedia, { opacity: 1 }, 'step1')

    tl.to(this.burgerMenuItems, {
      xPercent: 0, duration: 1, opacity: 1, ease: 'power2.out', stagger: {
        from: 'center', amount: 0.5
      }
    }, 'step1-=0.5')

    tl.to(this.burgerMenuPanel, {
      duration: 0.7, clipPath: 'inset(-2% 100% -2% 0%)', ease: 'power2.inOut', stagger: {
        from: 'random', amount: 0.35
      }
    }, 'step1')
  }

  /**
   * Animates the menu closing
   *
   * @param {event} e - The click event
   * @param {bool} force - Forces the menu to close
   *
   * NOTE: Turn `this.animating` to `false` on anim END
   * NOTE: Turn `this.opened` to `false` on anim END
   *
   * @returns {void}
   */
  close(e) {
    this.opened = false
    this.disabled(false)
    App.cursor.toggleScroll(false)
    this.toggleBurgerMenuActive(false)
    this.toggleBtnBurger(false)

    const tl = gsap.timeline({
      onComplete: () => {
        this.burgerCount = 0
        this.burgerMenuActive = this.burgerMenuItems[this.burgerCount]
        gsap.set(this.currentImg, { backgroundImage: 'url(' + this.burgerMenuActive.img.currentSrc + ')' })
        this.toggleBurgerMenuActive(true)
        this.animating = false
        this.disabled(true)
        App.scroll(true)
      }
    })

    tl.to(this.burgerMenuItems, {
      xPercent: -100, duration: 1, opacity: 0, ease: 'power2.inOut', stagger: {
        from: 'start', amount: 0.5
      }
    }, 'start')

    tl.to(this.burgerMenuPanel, {
      duration: 0.7, clipPath: 'inset(-2% 0% -2% 0%)', ease: 'power2.out', stagger: {
        from: 'random', amount: 0.15
      }
    }, 'start')

    tl.addLabel('step1', '-=0.5')

    tl.set(this.burgerMenuMedia, { opacity: 0 }, 'step1')

    tl.to(this.burgerBg, {
      opacity: 0, duration: 0.7, ease: 'power2.out'
    }, 'step1')

    tl.set(this.burgerMenu, { opacity: 0 })
    tl.set(this.burgerMenuItems, { y: 0 })

  }

  disabled(bool) {
    this.burgerMenu.classList.toggle('pointer-events-none', bool)
  }

  toggleBtnBurger(bool) {
    this.burgerBtn.classList.toggle('active', bool)
  }

  /**
   * Toggles the menu opening/closing
   *
   * @returns {void}
   */
  toggle() {
    if (this.animating) return

    this.animating = true
    this.opened ? this.close() : this.open()
  }

  show(bool) {
    return gsap.to(this.el, {
      duration: 0.7, opacity: bool ? 1 : 0, ease: 'power2.out'
    })
  }

  /**
   * Called by App.js on `resize` event
   *
   * @returns {void}
   */
  resize() {
  }

  scroll() {
  }

  /**
   * Called on every page change (Highway's `NAVIGATION_IN` event).
   *
   * @param {Object} [options={}] - An object with useful properties.
   * @param {Object} options.to - The destination page. to.page = the new page's `window.document`.
   * @param {String} options.location - Current location (url).
   * @returns {void}
   */
  refreshActivePage({ to } = {}) {
    if (to) {
      // this.refreshTranslationsUrls(to.page)
      this.refreshMenuClasses(to.page)
      this.refreshAdminBar(to.page)
    }
  }

  /**
   * Refreshes the lang-switcher urls with new pages translations url.
   *
   * @param {HTMLElement} page - The destination page element in which a new language list will be fetched.
   * @returns {void}
   */
  // refreshTranslationsUrls(page) {
  //   const newUrlsEls = page.querySelectorAll('.languages-list [data-lang]')

  //   if (!newUrlsEls || !this.langSwitchers) return

  //   for (const urlEl of newUrlsEls) {
  //     for (const langSwitcherEl of this.langSwitchers) {
  //       // If element is same language as target, change its url to new one.
  //       if (urlEl.dataset.lang === langSwitcherEl.dataset.lang) {
  //         langSwitcherEl.href = urlEl.dataset.url

  //         if (urlEl.classList.contains('active')) langSwitcherEl.classList.add('active')
  //         else langSwitcherEl.classList.remove('active')
  //       }
  //     }
  //   }
  // }

  /**
   * Refreshes the main menu classes.
   *
   * @param {HTMLElement} page - The destination page element in which a new language list will be fetched.
   * @returns {void}
   */
  refreshMenuClasses(page) {
    const items = document.querySelectorAll('.main-navigation .menu-item')
    const newItems = page.querySelectorAll('.main-navigation .menu-item')

    newItems.forEach((item, index) => {
      items[index].className = item.className
    });
  }

  /**
   * Refreshes WP admin bar.
   *
   * @param {HTMLElement} page - The destination page element in which a new language list will be fetched.
   * @returns {void}
   */
  refreshAdminBar(page) {
    const adminBar = document.querySelector('#wpadminbar')

    if (adminBar) {
      const newAdminBar = page.querySelector('#wpadminbar')

      if (newAdminBar) {
        const links = newAdminBar.querySelectorAll('a')

        adminBar.remove()
        this.adminBarAddTarget(links)
        document.body.appendChild(newAdminBar)
      }
    }
  }

  /**
   * Refreshes WP admin bar links target attributes.
   *
   * @param {HTMLElement} page - The destination page element in which a new language list will be fetched.
   * @returns {void}
   */
  adminBarAddTarget(links) {
    if (links.length > 0) links.forEach((link) => link.setAttribute('target', '_blank'))
  }
}
